/**
 * @author Tommy Brière
 * @copyright (c) 2015 Groupe PVP
 * @fileoverview Cookie utility
**/
(function(document) {
    "use strict";
	var $g = window.Cookie = {};
	
	$g.write = function(nom, valeur, path) {
		path=path||"/";
		document.cookie=nom+"="+escape(valeur)+"; path="+path;
	};
		
	$g.del = function(nom, path) {
		path=path||"/";
		document.cookie = nom + "=" + ";expires=Thu, 01-Jan-1970 00:00:01 GMT"+"; path="+path;
	};
	
	function getCookieVal(offset)
	{
		var endstr=document.cookie.indexOf (";", offset);
		if (endstr==-1) endstr=document.cookie.length;
		return unescape(document.cookie.substring(offset, endstr));
	};
	
	/**
	* Lecture de la valeur d'un cookie
	* Prend en compte le fait que l'item pourrait se trouver plusieurs fois dans la chaine cookie
	**/
	$g.get = function(nom) {
		var arg=nom+"=";
		var alen=arg.length;
		var clen=document.cookie.length;
		var i=0;
		while (i<clen){
			var j=i+alen;
			if (document.cookie.substring(i, j)==arg) {
				return getCookieVal(j);}
			i=document.cookie.indexOf(" ",i)+1;
			if (i==0) {
				break;
			}
		}
		return null;
	};
	
})(document);